const baseUrl = import.meta.env.VITE_BASE_URL as string | undefined;

// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const WITH_PAYUNICARD: boolean = true;
export const isDevelopment = baseUrl?.includes("https://devkyc.payunicard.ge");

export const getErrorUrl = (language: string) =>
  isDevelopment
    ? `https://gi.edgesless.space/${language}/verification/external`
    : `https://whitebit.ge/${language}/verification/external`;

export const getPayunicardRegisterUrl = (language: string, guid: string) =>
  isDevelopment
    ? `https://dev.payunicard.ge/${language}/register?with_verification=${guid}`
    : `https://payunicard.ge/${language}/register?with_verification=${guid}`;
